import React, { useMemo, useState } from 'react';
import styled, { css } from 'styled-components';

import { COLORS } from 'src/utils/constants';

const PageWrapper = ({ children, admin = false }) => {
  const [selectedView, setSelectedView] = useState(admin ? { label: 'Backlog', value: 'backlog' } : { label: "Plan d'actions", value: 'actions' });
  const views = useMemo(() => {
    return admin
      ? [
          {
            label: 'Backlog',
            value: 'backlog',
            onClick: () => {
              setSelectedView({ label: 'Backlog', value: 'backlog' });
            },
          },
          {
            label: 'Actions préparées',
            value: 'actionsPrepared',
            onClick: () => {
              setSelectedView({ label: 'Actions préparées', value: 'actionsPrepared' });
            },
          },
          {
            label: "Plan d'actions",
            value: 'actions',
            onClick: () => {
              setSelectedView({ label: "Plan d'actions", value: 'actions' });
            },
          },
        ]
      : [
          {
            label: "Plan d'actions",
            value: 'actions',
            onClick: () => {
              setSelectedView({ label: "Plan d'actions", value: 'actions' });
            },
          },
          {
            label: 'Audits',
            value: 'audits',
            onClick: () => {
              setSelectedView({ label: 'Audits', value: 'audits' });
            },
          },
          // TODO!: TO be activated with rights space
          // {
          //   label: 'Demande des droits',
          //   value: 'requests',
          //   onClick: () => {
          //     setSelectedView({ label: 'Demande des droits', value: 'requests' });
          //   },
          // },
        ];
  }, []);

  // Clone the child and pass additional props
  const modifiedChild = React.cloneElement(children, {
    view: selectedView.value,
  });

  return (
    <Container admin={admin}>
      <Content>
        {!admin && <PageTitle>{selectedView.label}</PageTitle>}
        <TabContainer>
          {views.map((view, index) => {
            return (
              <Tab key={index} selected={view.value === selectedView.value} onClick={view.onClick}>
                <span>{view.label}</span>
              </Tab>
            );
          })}
        </TabContainer>
        {modifiedChild}
      </Content>
    </Container>
  );
};

export default PageWrapper;

const Content = styled.div<{ scrollable?: boolean }>`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const Container = styled.div<{ admin: boolean }>`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: auto;
  ${({ admin }) =>
    !admin &&
    `
    margin-top: 6.3rem;
`}
  padding-right: 3rem;
  padding-left: 3rem;
  height: calc(100% - 6.3rem);
`;

const TabContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 20px;
`;

const Tab = styled.div<{ selected: boolean }>`
  padding: 10px 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  color: black;
  font-family: 'Roboto', sans-serif;
  font-size: 1.1em;
  transition: all 0.2s ease-in-out;
  text-transform: uppercase;
  font-weight: 500;
  border: ${COLORS.MediumGrey} solid 1px;
  border-radius: 5px;
  span {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 100%;
  }

  &:hover {
    cursor: pointer;
    background-color: ${COLORS.darkBlue};
    color: white;
  }

  ${({ selected }) =>
    selected &&
    css`
      background-color: ${COLORS.darkBlue};
      color: white;
    `}
`;

const PageTitle = styled.h1`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  cursor: pointer;
  color: black;
  svg {
    margin-left: 1rem;
    transition: transform 0.3s ease;
  }
`;
